import type React from 'react';
import { useRef } from 'react';

import { observer } from 'mobx-react';

import { useButton } from '@react-aria/button';

import type { AriaButtonProps } from '@react-types/button';

export interface IProps extends AriaButtonProps {
  className?: string;
  disabled?: boolean;
}

const ClickButton: React.FC<IProps> = observer((props) => {
  const ref = useRef<HTMLButtonElement>(null);
  const { buttonProps } = useButton({ ...props, isDisabled: props.disabled }, ref);
  const { children } = props;

  return (
    <button {...buttonProps} ref={ref} className={props.className ? props.className : 'btn'}>
      {children}
    </button>
  );
});

export default ClickButton;
